import React from "react";
import { motion } from "framer-motion";

const events = [
  {
    id: 1,
    name: "Quad Cane (Cane with four feet)",
    image: "/images/medical1.jpeg",
    description:
      "Helps patients with limited mobility walk safely and maintain balance, providing extra stability with four contact points.",
  },
  {
    id: 2,
    name: "Commode Chair (Portable toilet seat)",
    image: "/images/medical2.jpeg",
    description:
      "Designed for elderly or disabled individuals who face difficulty accessing regular toilets, ensuring comfort and hygiene.",
  },
  {
    id: 3,
    name: "Walker (Frame for support while walking)",
    image: "/images/medical3.jpeg",
    description:
      "Provides physical support to individuals recovering from surgery, injury, or weakness while walking independently.",
  },
  {
    id: 4,
    name: "Hospital Bed (Adjustable patient bed)",
    image: "/images/medical4.jpeg",
    description:
      "An adjustable bed offering comfort and ease for patients during recovery or long-term care at home or hospitals.",
  },
  {
    id: 5,
    name: "Wheelchair",
    image: "/images/medical5.jpeg",
    description:
      "Essential mobility aid for patients with movement challenges, enabling freedom and independence in daily activities.",
  },
  {
    id: 6,
    name: "Oxygen Concentrator (Device to supply oxygen)",
    image: "/images/medical6.jpeg",
    description:
      "Provides a continuous flow of medical-grade oxygen for patients with respiratory disorders or breathing difficulties.",
  },
];

const cardVariant = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
};

const EventCard = ({ image, name, description, index }) => {
  return (
    <motion.div
      variants={cardVariant}
      initial="initial"
      animate="animate"
      transition={{ delay: index * 0.1, duration: 0.5 }}
      className="w-[320px] h-[400px] mt-[1rem] mb-[1rem] bg-white rounded-xl shadow-md p-4 flex-shrink-0 flex flex-col justify-between text-left mx-3 border border-gray-200 transition-all duration-300 hover:shadow-xl hover:border-brandRed hover:-translate-y-2 hover:bg-gray-50"
      whileHover={{ scale: 1.05 }}
    >
      <img
        src={image}
        alt={name}
        className="max-h-[230px] w-auto object-cover rounded-lg mb-2"
      />
      <h3 className="text-xl font-bold text-brandRed mb-1">{name}</h3>
      <p className="text-gray-600 text-sm leading-snug">{description}</p>
    </motion.div>
  );
};

const Event = () => {
  return (
    <section className="py-16 bg-gray-100 relative overflow-hidden mt-[6rem]">
      {/* ====== Title ====== */}
      <div className="text-center mb-12">
        <h2 className="text-3xl font-semibold text-brandRed relative inline-block group">
          <span className="relative z-10">Medical Accessories</span>
          <span className="absolute left-0 bottom-0 h-1 bg-brandRed transition-all duration-300 w-0 group-hover:w-full"></span>
        </h2>
      
      </div>

      {/* ====== Scrolling Medical Cards ====== */}
      <div className="overflow-hidden">
        <motion.div
          className="flex space-x-[40px]"
          animate={{ x: ["0%", "-100%"] }}
          transition={{
            duration: 50,
            repeat: Infinity,
            ease: "linear",
          }}
        >
          {[...events, ...events].map((event, index) => (
            <EventCard
              key={index}
              image={event.image}
              name={event.name}
              description={event.description}
              index={index}
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Event;
